export const CommonTranslationKeys = {
    SAVED_SUCSESSFULLY: 'atp.common.saved_successfully',
} as const;
